import { AutocompletAble } from 'ui/DropdownItems/types';

export function sortAlphabetically<T>(
    options: AutocompletAble<T>[],
): AutocompletAble<T>[] {
    return options.sort(
        (a, b) => -new Intl.Collator().compare(b.label, a.label),
    );
}
